/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useRef, useState, useEffect } from "react";
import close from "../../../assets/images/model/close.svg";
import filePlus from "../../../assets/images/model/upload_arrow.svg";
import infoCreate from "../../../assets/images/model/info-create.svg";
import polygonArrow from "../../../assets/images/model/Polygon-dowan-arrow.svg";
import AudioPlayer, { RHAP_UI } from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import "./MediaSource.css";
import { useDispatch } from "react-redux";
import { uploadMedia } from "../../../Store/api/create";

const AudioUploadComponent = ({
  setUploadAudioShow,
  onAudioUploaded,
  onSuccess,
}) => {
  const dispatch = useDispatch();
  const [uploadAudio, setUploadAudio] = useState(true);
  const [uploadLoadedAudio, setUploadLoadedAudio] = useState(false);
  const [audioFile, setAudioFile] = useState(null);
  const [autoPlay, setAutoPlay] = useState(false);
  const [audioDuration, setAudioDuration] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const audioRef = useRef();
  const dropRef = useRef();
  const circleRef = useRef();
  const inputRef = useRef(null);

  const handleLoadedMetadata = () => {
    if (audioRef.current && audioRef.current.audio.current) {
      const duration = audioRef.current.audio.current.duration;
      setAudioDuration(duration);
    }
  };

  useEffect(() => {
    const items = document.querySelectorAll(".progress-item");

    const newIntervals = Array.from(items).map((_, index) => {
      return setInterval(() => {
        // Calculate the updated percentage based on the upload progress
        const updatedPercentage = (uploadProgress / 100) * 100;

        // Update the progress bar styles and data attributes
        items[
          index
        ].style.background = `conic-gradient(var(--Purple-700, #6700B2) calc(${updatedPercentage}%),var(--Purple-300, #DDD5EB) 0deg)`;
        items[index].setAttribute("data-value", `${updatedPercentage}%`);
        items[index].textContent = `${updatedPercentage}%`;

        // Check if upload progress has reached 100%
        if (uploadProgress === 100) {
          // If upload is complete, clear the interval
          clearInterval(newIntervals[index]);
        }
      }, 15);
    });

    // Clear intervals on component unmount
    return () => {
      newIntervals.forEach((interval) => clearInterval(interval));
    };
  }, [uploadProgress]);

  const handleUpload = (file) => {
    setIsLoading(true);
    const { type } = file;
    dispatch(
      uploadMedia({
        body: { fileType: type },
        onSuccess: async (res) => {
          try {
            await putFile(file, res.data.data.url);
            setUploadAudio(false);
            setIsLoading(false);
            setUploadLoadedAudio(true);
            setAudioFile(file);
            onSuccess(res.data.data.key, "", "");
          } catch (error) {
            setIsLoading(false);
            console.error("Upload failed:", error);
          }
        },
        onError: (err) => {},
      })
    );
    // if (file) {
    //   setIsLoading(true); // Start loading animation
    //   let progress = 0;

    //   const interval = setInterval(() => {
    //     progress += 20;
    //     setUploadProgress(progress);
    //     updateProgress(progress);

    //     if (progress >= 100) {
    //       clearInterval(interval);
    //       setTimeout(() => {
    //         setAudioFile(file);
    //         setUploadAudio(false);
    //         setUploadLoadedAudio(true);
    //         setIsLoading(false); // Stop loading animation
    //       }, 500); // Small delay to show 100%
    //     }
    //   }, 500); // Update progress every 500ms to make the total duration 5 seconds
    // }
  };

  const putFile = (file, url) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.open("PUT", url, true);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const progress = (event.loaded / event.total) * 100;
          setUploadProgress(Math.round(progress));
        }
      };

      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr.response);
        } else {
          reject(new Error(`Upload failed: ${xhr.statusText}`));
        }
      };

      xhr.onerror = () => reject(new Error("Network error occurred"));

      xhr.send(file);
    });
  };

  const updateProgress = (progress) => {
    if (circleRef.current) {
      const circle = circleRef.current.querySelector("b");
      const deg = (progress / 100) * 360;

      if (circle) {
        if (deg <= 180) {
          circle.style.setProperty("--rotate-before", `rotate(${deg}deg)`);
          circle.style.setProperty("--rotate-after", "rotate(0deg)");
        } else {
          circle.style.setProperty("--rotate-before", "rotate(180deg)");
          circle.style.setProperty("--rotate-after", `rotate(${deg - 180}deg)`);
        }
      }
    }
  };

  useEffect(() => {
    updateProgress(uploadProgress);
  }, [uploadProgress]);

  const handleClose = () => {
    setUploadAudioShow(false);
  };

  const handleFileUpload = () => {
    setUploadAudioShow(false);
    if (onAudioUploaded && audioFile) {
      onAudioUploaded(audioFile);
    }
  };

  const formatTime = (time) => {
    if (!time) return "0:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    dropRef.current.classList.add("drag-over");
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    event.stopPropagation();
    dropRef.current.classList.add("drag-over");
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    dropRef.current.classList.remove("drag-over");
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    dropRef.current.classList.remove("drag-over");
    const file = event.dataTransfer.files[0];
    handleUpload(file);
  };

  return (
    <div>
      <div
        className="modal custom_background custom_modal_create"
        id="upload_book"
        style={{ display: "block" }}
        tabIndex="-1"
        aria-labelledby="upload_bookLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button
                onClick={handleClose}
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <img src={close} alt="close" />
              </button>
            </div>
            <div className="modal-body-cre">
              <h4>add audio</h4>
              {uploadAudio && !isLoading && (
                <Fragment>
                  <p>
                    Drag and drop an audio file from your computer. Add
                    attribution in the next step.
                  </p>
                  <form action="" className="upload_book">
                    <div
                      className="upload_book_inner my-40 mb-0"
                      ref={dropRef}
                      onDragOver={handleDragOver}
                      onDragEnter={handleDragEnter}
                      onDragLeave={handleDragLeave}
                      onClick={() => {
                        inputRef.current.click();
                      }}
                      onDrop={handleDrop}
                    >
                      <div className="drag_and_drop_box" htmlFor="Drag-file">
                        <div className="upload_content">
                          <div className="icon-create mb-24">
                            <img src={filePlus} alt="upload" />
                          </div>
                          <div className="deflat_content">
                            <h6 className="f-size-18 theme__primary__text">
                              <span>Drag and drop file, or </span>
                              <label
                                className="cursor"
                                style={{ cursor: "pointer" }}
                              >
                                Browse
                              </label>
                              <input
                                type="file"
                                ref={inputRef}
                                id="Drag-file"
                                onChange={(e) =>
                                  handleUpload(e.target.files[0])
                                }
                                accept="audio/*"
                                style={{ display: "none" }}
                              />
                            </h6>
                            <p>Supports mp3 files | Max 50mb size</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </Fragment>
              )}
              {isLoading && (
                <Fragment>
                  <form action="" className="upload_book">
                    <div className="upload_book_inner my-40 mb-0">
                      <div
                        className="drag_and_drop_box upload-boarder"
                        htmlFor="Drag-file"
                      >
                        <div className="upload_content">
                          <div className="icon mb-24"> </div>
                          <div className="deflat_content ">
                            <div id="progress">
                              <div data-num="40" className="progress-item">
                                sd
                              </div>
                            </div>
                            <h6 className="f-size-18 theme__primary__text">
                              Uploading audio...
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </Fragment>
              )}

              {uploadLoadedAudio && audioFile && (
                <Fragment>
                  <div className="add_img_cre">
                    <form action="" className="pick_from_library">
                      <div className="pick_from_library_filter_wrap">
                        <div className="pick_from_library_filter my-40 ">
                          <div className="conten_center my-40 mb-24">
                            <div
                              className="drag_and_drop_box upload-boarder audio_padding"
                              htmlFor="Drag-file"
                            >
                              <div className="deflat_content audio_file_parent">
                                <span className="audio_file">
                                  {audioFile.name}
                                </span>
                                <span className="audio_size">
                                  {formatTime(audioDuration)} (
                                  {Math.round(audioFile.size / (1024 * 1024))}
                                  MB)
                                </span>
                              </div>
                              <AudioPlayer
                                ref={audioRef}
                                style={{ width: "100%" }}
                                autoPlay={autoPlay}
                                src={URL.createObjectURL(audioFile)}
                                customAdditionalControls={[]}
                                customVolumeControls={[]}
                                showJumpControls={false}
                                customProgressBarSection={[
                                  RHAP_UI.CURRENT_TIME,
                                  <div className="slash_time" key="slash">
                                    /
                                  </div>,
                                  RHAP_UI.DURATION,
                                  RHAP_UI.PROGRESS_BAR,
                                ]}
                                onLoadedMetadata={handleLoadedMetadata}
                              />
                            </div>
                          </div>
                          <div className="icon">
                            <div className="tooltip_wrap Attribution">
                              <h2 className="icon_h2 mb-0">Title </h2>
                            </div>
                            <input
                              style={{ height: "60px" }}
                              type="text"
                              className="pick_from_input_cre border_color"
                              placeholder="Add a title"
                            />
                          </div>
                          <div className="icon">
                            <div className="tooltip_wrap Attribution">
                              <h2 className="icon_h2 mb-0">
                                Attribution{" "}
                                <img
                                  src={infoCreate}
                                  className="info_tooltip"
                                  alt="Info"
                                />
                              </h2>
                              <p>
                                Provide the source of the audio to give creator
                                credit <img src={polygonArrow} alt="Polygo" />
                              </p>
                            </div>
                            <input
                              style={{ height: "60px" }}
                              type="text"
                              className="pick_from_input_cre border_color"
                              placeholder="Paste a link..."
                            />
                          </div>
                        </div>
                      </div>
                      <div className="modal-btn">
                        <button
                          type="button"
                          className="btn-black_create"
                          onClick={handleFileUpload}
                        >
                          Done
                        </button>
                      </div>
                    </form>
                  </div>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AudioUploadComponent;
